import { Initiative } from "../../interfaces"

export const initiatives: Initiative[] = require("./initiatives.json")
export * from "./updateBudget"
export * from "./initiativesUpdateMetrics"
